package link.erpango.quip.ui.noteimport

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.imePadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Checkbox
import androidx.compose.material.CheckboxDefaults
import androidx.compose.material.CircularProgressIndicator
import androidx.compose.material.DropdownMenu
import androidx.compose.material.DropdownMenuItem
import androidx.compose.material.Icon
import androidx.compose.material.IconButton
import androidx.compose.material.LinearProgressIndicator
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Scaffold
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.ArrowBack
import androidx.compose.material.icons.filled.CheckCircle
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Warning
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import link.erpango.quip.domain.entities.DSparePartCatalog
import link.erpango.quip.domain.entities.DSparePartType
import link.erpango.quip.domain.entities.DVehicle
import link.erpango.quip.domain.extraction.ExtractionConfidence
import link.erpango.quip.domain.noteimport.BlockReason
import link.erpango.quip.domain.noteimport.FieldSource
import link.erpango.quip.domain.noteimport.ItemStatus
import link.erpango.quip.domain.noteimport.MaintenanceDraft
import link.erpango.quip.domain.noteimport.SparePartDraft
import link.erpango.quip.domain.noteimport.SuggestedField
import link.erpango.quip.domain.noteimport.VehicleDraft
import link.erpango.quip.domain.noteimport.VehicleRef
import link.erpango.quip.features.noteimport.BulkStep
import link.erpango.quip.features.noteimport.NoteImportBulkUiState
import link.erpango.quip.features.noteimport.NoteImportBulkViewModel
import link.erpango.quip.features.noteimport.ReviewIssue
import link.erpango.quip.theme.QuipColors
import link.erpango.quip.theme.QuipDimens
import link.erpango.quip.ui.DatePickerField
import link.erpango.quip.ui.components.QuipCard
import link.erpango.quip.ui.components.QuipDialogGeneric
import link.erpango.quip.ui.components.QuipDropdownTextField
import link.erpango.quip.ui.components.QuipPrimaryButton
import link.erpango.quip.ui.components.QuipSecondaryButton
import link.erpango.quip.ui.components.QuipTextBadge
import link.erpango.quip.ui.components.QuipTextField
import link.erpango.quip.ui.components.QuipTransparentHeader
import link.erpango.quip.ui.components.VehicleColorPicker
import link.erpango.quip.ui.getSparePartCategoryString
import link.erpango.quip.ui.getSparePartTypeString
import org.jetbrains.compose.resources.stringResource
import quip.composeapp.generated.resources.Res
import quip.composeapp.generated.resources.brand
import quip.composeapp.generated.resources.cancel
import quip.composeapp.generated.resources.category_header
import quip.composeapp.generated.resources.color
import quip.composeapp.generated.resources.cost_label
import quip.composeapp.generated.resources.date_label
import quip.composeapp.generated.resources.description
import quip.composeapp.generated.resources.kilometers_label
import quip.composeapp.generated.resources.model
import quip.composeapp.generated.resources.note_import_already_in_garage
import quip.composeapp.generated.resources.note_import_bulk_apply
import quip.composeapp.generated.resources.note_import_bulk_assign_to
import quip.composeapp.generated.resources.note_import_bulk_back_to_note
import quip.composeapp.generated.resources.note_import_bulk_banner
import quip.composeapp.generated.resources.note_import_bulk_complete_first
import quip.composeapp.generated.resources.note_import_bulk_confirm_message
import quip.composeapp.generated.resources.note_import_bulk_confirm_title
import quip.composeapp.generated.resources.note_import_bulk_create
import quip.composeapp.generated.resources.note_import_bulk_creating
import quip.composeapp.generated.resources.note_import_bulk_done_summary
import quip.composeapp.generated.resources.note_import_bulk_done_title
import quip.composeapp.generated.resources.note_import_bulk_edit_maintenance
import quip.composeapp.generated.resources.note_import_bulk_edit_spare_part
import quip.composeapp.generated.resources.note_import_bulk_edit_vehicle
import quip.composeapp.generated.resources.note_import_bulk_entry
import quip.composeapp.generated.resources.note_import_bulk_go_to_garage
import quip.composeapp.generated.resources.note_import_bulk_intro
import quip.composeapp.generated.resources.note_import_bulk_issue_vehicle
import quip.composeapp.generated.resources.note_import_bulk_issue_vehicle_not_selected
import quip.composeapp.generated.resources.note_import_bulk_missing
import quip.composeapp.generated.resources.note_import_bulk_new_vehicle
import quip.composeapp.generated.resources.note_import_bulk_no_vehicle
import quip.composeapp.generated.resources.note_import_bulk_nothing_selected
import quip.composeapp.generated.resources.note_import_bulk_result_blocked_incomplete
import quip.composeapp.generated.resources.note_import_bulk_result_blocked_no_vehicle
import quip.composeapp.generated.resources.note_import_bulk_result_blocked_vehicle
import quip.composeapp.generated.resources.note_import_bulk_result_created
import quip.composeapp.generated.resources.note_import_bulk_result_existing
import quip.composeapp.generated.resources.note_import_bulk_result_failed
import quip.composeapp.generated.resources.note_import_bulk_retry_failed
import quip.composeapp.generated.resources.note_import_bulk_unassigned
import quip.composeapp.generated.resources.note_import_no_results
import quip.composeapp.generated.resources.note_import_source_ai
import quip.composeapp.generated.resources.owner
import quip.composeapp.generated.resources.plate
import quip.composeapp.generated.resources.quantity_label
import quip.composeapp.generated.resources.reference_optional_label
import quip.composeapp.generated.resources.spare_part_type_label
import quip.composeapp.generated.resources.vin
import quip.composeapp.generated.resources.year

/**
 * "Importar desde nota" from the garage: paste, review every detected item (check, edit,
 * reassign) and create them all at once. Nothing is saved before "Crear".
 */
@Composable
fun NoteImportBulkScreen(
    viewModel: NoteImportBulkViewModel,
    sparePartCatalog: DSparePartCatalog,
    onBack: () -> Unit,
    onFinished: () -> Unit,
) {
    val state by viewModel.uiState.collectAsState()
    var showConfirm by remember { mutableStateOf(false) }
    var editing by remember { mutableStateOf<String?>(null) }

    Scaffold(
        backgroundColor = QuipColors.colorBackground,
        bottomBar = { BulkBottomBar(state, onCreate = { showConfirm = true }, onRetry = viewModel::retryFailed, onFinished = onFinished) },
    ) { padding ->
        Column(modifier = Modifier.fillMaxSize().padding(padding).imePadding()) {
            QuipTransparentHeader {
                Row(verticalAlignment = Alignment.CenterVertically) {
                    IconButton(onClick = onBack, enabled = state.step != BulkStep.CREATING) {
                        Icon(Icons.Default.ArrowBack, contentDescription = null, tint = QuipColors.colorText)
                    }
                    Spacer(Modifier.width(QuipDimens.padding8))
                    Text(
                        text = stringResource(Res.string.note_import_bulk_entry),
                        style = MaterialTheme.typography.h5,
                        fontWeight = FontWeight.Bold,
                        color = QuipColors.colorText,
                    )
                }
            }
            Column(
                modifier = Modifier.fillMaxSize().verticalScroll(rememberScrollState()).padding(horizontal = QuipDimens.padding16),
                verticalArrangement = Arrangement.spacedBy(QuipDimens.padding12),
            ) {
                when (state.step) {
                    BulkStep.INPUT -> NoteInputSection(
                        analysis = state.analysis,
                        controller = viewModel.analysis,
                        intro = stringResource(Res.string.note_import_bulk_intro),
                    )

                    BulkStep.REVIEW -> ReviewList(
                        state = state,
                        catalog = sparePartCatalog,
                        onBackToNote = viewModel::backToInput,
                        onToggle = viewModel::toggle,
                        onEdit = { editing = it },
                        onAssign = viewModel::assign,
                    )

                    BulkStep.CREATING, BulkStep.DONE -> ResultList(state, sparePartCatalog)
                }
                Spacer(Modifier.height(QuipDimens.padding24))
            }
        }
    }

    if (showConfirm) {
        QuipDialogGeneric(
            title = stringResource(Res.string.note_import_bulk_confirm_title, state.itemsToCreate),
            message = stringResource(Res.string.note_import_bulk_confirm_message),
            confirmButtonText = stringResource(Res.string.note_import_bulk_create, state.itemsToCreate),
            dismissButtonText = stringResource(Res.string.cancel),
            onConfirm = {
                showConfirm = false
                viewModel.create()
            },
            onDismiss = { showConfirm = false },
        )
    }

    editing?.let { id ->
        val draft = state.draft
        draft.vehicles.firstOrNull { it.id == id }?.let { vehicle ->
            VehicleEditDialog(vehicle, onDismiss = { editing = null }) { edited ->
                viewModel.updateVehicle(id) { edited }
                editing = null
            }
        }
        draft.maintenances.firstOrNull { it.id == id }?.let { maintenance ->
            MaintenanceEditDialog(maintenance, onDismiss = { editing = null }) { edited ->
                viewModel.updateMaintenance(id) { edited }
                editing = null
            }
        }
        draft.spareParts.firstOrNull { it.id == id }?.let { part ->
            SparePartEditDialog(part, sparePartCatalog, onDismiss = { editing = null }) { edited ->
                viewModel.updateSparePart(id) { edited }
                editing = null
            }
        }
    }
}

// --- Review --------------------------------------------------------------------------------------

@Composable
private fun ReviewList(
    state: NoteImportBulkUiState,
    catalog: DSparePartCatalog,
    onBackToNote: () -> Unit,
    onToggle: (String) -> Unit,
    onEdit: (String) -> Unit,
    onAssign: (String, VehicleRef) -> Unit,
) {
    val draft = state.draft
    Row(verticalAlignment = Alignment.CenterVertically) {
        Icon(Icons.Default.Info, contentDescription = null, tint = QuipColors.colorPrimary)
        Spacer(Modifier.width(QuipDimens.padding8))
        Text(
            text = stringResource(Res.string.note_import_bulk_banner),
            style = MaterialTheme.typography.body2,
            color = QuipColors.colorText,
            modifier = Modifier.weight(1f),
        )
    }
    TextButton(onClick = onBackToNote) {
        Text(stringResource(Res.string.note_import_bulk_back_to_note), color = QuipColors.colorPrimary)
    }
    if (draft.isEmpty) {
        Text(stringResource(Res.string.note_import_no_results), color = QuipColors.colorTextSecondary)
        return
    }

    val assignOptions = assignOptions(state)
    @Composable
    fun Items(maintenances: List<MaintenanceDraft>, parts: List<SparePartDraft>) {
        maintenances.forEach { maintenance ->
            ReviewRow(
                title = maintenance.description?.value ?: stringResource(Res.string.date_label),
                subtitle = maintenanceSubtitle(maintenance),
                checked = maintenance.id in state.selected,
                issues = issueLabels(state.issuesOf(maintenance)),
                aiSuggested = maintenance.description?.source == FieldSource.AI,
                onToggle = { onToggle(maintenance.id) },
                onEdit = { onEdit(maintenance.id) },
                assign = AssignMenu(assignOptions.filterNot { it.ref == VehicleRef.Unassigned }) { onAssign(maintenance.id, it) },
            )
        }
        parts.forEach { part ->
            ReviewRow(
                title = partTitle(part, catalog),
                subtitle = partSubtitle(part),
                checked = part.id in state.selected,
                issues = issueLabels(state.issuesOf(part)),
                aiSuggested = part.typeId?.source == FieldSource.AI,
                onToggle = { onToggle(part.id) },
                onEdit = { onEdit(part.id) },
                assign = AssignMenu(assignOptions) { onAssign(part.id, it) },
            )
        }
    }

    // One group per detected vehicle, with the items that belong to it.
    draft.vehicles.forEach { vehicle ->
        val isNew = state.isNew(vehicle)
        ReviewRow(
            title = vehicleTitle(vehicle),
            subtitle = vehicleSubtitle(vehicle),
            checked = vehicle.id in state.selected,
            checkable = isNew,
            badge = stringResource(if (isNew) Res.string.note_import_bulk_new_vehicle else Res.string.note_import_already_in_garage),
            issues = if (vehicle.id in state.selected) issueLabels(state.issuesOf(vehicle)) else emptyList(),
            header = true,
            onToggle = { onToggle(vehicle.id) },
            onEdit = if (isNew) ({ onEdit(vehicle.id) }) else null,
        )
        Column(modifier = Modifier.padding(start = QuipDimens.padding16), verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
            val ref = VehicleRef.Draft(vehicle.id)
            Items(draft.maintenances.filter { it.vehicle == ref }, draft.spareParts.filter { it.vehicle == ref })
        }
    }

    // Items reassigned to a vehicle already in the garage.
    draft.maintenances.map { it.vehicle }.plus(draft.spareParts.map { it.vehicle })
        .filterIsInstance<VehicleRef.Garage>().distinct().forEach { ref ->
            val garageVehicle = state.garage.firstOrNull { it.vin == ref.vin }
            GroupTitle(garageVehicle?.let { garageLabel(it) } ?: ref.vin)
            Items(draft.maintenances.filter { it.vehicle == ref }, draft.spareParts.filter { it.vehicle == ref })
        }

    val unassignedMaintenances = draft.maintenances.filter { it.vehicle == VehicleRef.Unassigned }
    val unassignedParts = draft.spareParts.filter { it.vehicle == VehicleRef.Unassigned }
    if (unassignedMaintenances.isNotEmpty() || unassignedParts.isNotEmpty()) {
        GroupTitle(stringResource(Res.string.note_import_bulk_unassigned))
        Items(unassignedMaintenances, unassignedParts)
    }
}

private data class AssignOption(val label: String, val ref: VehicleRef)

private class AssignMenu(val options: List<AssignOption>, val onSelected: (VehicleRef) -> Unit)

@Composable
private fun assignOptions(state: NoteImportBulkUiState): List<AssignOption> = buildList {
    state.draft.vehicles.filter { !state.isNew(it) || it.id in state.selected }.forEach {
        add(AssignOption(vehicleTitle(it), VehicleRef.Draft(it.id)))
    }
    val matched = state.draft.vehicles.mapNotNull { it.garageMatchVin }.toSet()
    state.garage.filter { it.vin !in matched }.forEach { add(AssignOption(garageLabel(it), VehicleRef.Garage(it.vin))) }
    add(AssignOption(stringResource(Res.string.note_import_bulk_no_vehicle), VehicleRef.Unassigned))
}

private fun garageLabel(vehicle: DVehicle): String = "${vehicle.brand} ${vehicle.model} · ${vehicle.plate}"

@Composable
private fun GroupTitle(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.subtitle1,
        fontWeight = FontWeight.Bold,
        color = QuipColors.colorText,
        modifier = Modifier.padding(top = QuipDimens.padding8),
    )
}

@Composable
private fun ReviewRow(
    title: String,
    subtitle: String,
    checked: Boolean,
    issues: List<String>,
    onToggle: () -> Unit,
    onEdit: (() -> Unit)?,
    checkable: Boolean = true,
    badge: String? = null,
    header: Boolean = false,
    aiSuggested: Boolean = false,
    assign: AssignMenu? = null,
) {
    QuipCard(
        modifier = Modifier.clickable(enabled = onEdit != null) { onEdit?.invoke() },
        elevation = if (header) QuipDimens.padding4 else QuipDimens.padding2,
    ) {
        Row(verticalAlignment = Alignment.CenterVertically) {
            if (checkable) {
                Checkbox(
                    checked = checked,
                    onCheckedChange = { onToggle() },
                    colors = CheckboxDefaults.colors(checkedColor = QuipColors.colorPrimary),
                )
            } else {
                Icon(Icons.Default.CheckCircle, contentDescription = null, tint = QuipColors.colorSuccess, modifier = Modifier.padding(QuipDimens.padding12))
            }
            Column(modifier = Modifier.weight(1f)) {
                Text(
                    text = title,
                    style = if (header) MaterialTheme.typography.subtitle1 else MaterialTheme.typography.body1,
                    fontWeight = FontWeight.Bold,
                    color = if (checked || !checkable) QuipColors.colorText else DisabledText,
                )
                if (subtitle.isNotBlank()) {
                    Text(subtitle, style = MaterialTheme.typography.caption, color = QuipColors.colorTextSecondary)
                }
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(QuipDimens.padding6),
                    verticalArrangement = Arrangement.spacedBy(QuipDimens.padding4),
                    modifier = Modifier.padding(top = QuipDimens.padding4),
                ) {
                    badge?.let { QuipTextBadge(text = it) }
                    if (aiSuggested) QuipTextBadge(text = stringResource(Res.string.note_import_source_ai))
                    if (checked && issues.isNotEmpty()) {
                        QuipTextBadge(
                            text = stringResource(Res.string.note_import_bulk_missing, issues.joinToString(", ")),
                            backgroundColor = QuipColors.colorError.copy(alpha = 0.15f),
                            textColor = QuipColors.colorError,
                        )
                    }
                }
                if (assign != null) {
                    var expanded by remember { mutableStateOf(false) }
                    Box {
                        TextButton(onClick = { expanded = true }) {
                            Text(stringResource(Res.string.note_import_bulk_assign_to), color = QuipColors.colorPrimary)
                        }
                        DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
                            assign.options.forEach { option ->
                                DropdownMenuItem(onClick = {
                                    expanded = false
                                    assign.onSelected(option.ref)
                                }) { Text(option.label) }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun issueLabels(issues: Set<ReviewIssue>): List<String> = issues.map { issue ->
    when (issue) {
        ReviewIssue.VIN -> stringResource(Res.string.vin)
        ReviewIssue.PLATE -> stringResource(Res.string.plate)
        ReviewIssue.BRAND -> stringResource(Res.string.brand)
        ReviewIssue.MODEL -> stringResource(Res.string.model)
        ReviewIssue.YEAR -> stringResource(Res.string.year)
        ReviewIssue.COLOR -> stringResource(Res.string.color)
        ReviewIssue.OWNER -> stringResource(Res.string.owner)
        ReviewIssue.DATE -> stringResource(Res.string.date_label)
        ReviewIssue.KILOMETERS -> stringResource(Res.string.kilometers_label)
        ReviewIssue.COST -> stringResource(Res.string.cost_label)
        ReviewIssue.CATEGORY -> stringResource(Res.string.category_header)
        ReviewIssue.TYPE -> stringResource(Res.string.spare_part_type_label)
        ReviewIssue.VEHICLE -> stringResource(Res.string.note_import_bulk_issue_vehicle)
        ReviewIssue.VEHICLE_NOT_SELECTED -> stringResource(Res.string.note_import_bulk_issue_vehicle_not_selected)
    }
}

// --- Bottom bar ------------------------------------------------------------------------------------

@Composable
private fun BulkBottomBar(state: NoteImportBulkUiState, onCreate: () -> Unit, onRetry: () -> Unit, onFinished: () -> Unit) {
    when (state.step) {
        BulkStep.INPUT -> Unit
        BulkStep.REVIEW -> Column(Modifier.padding(QuipDimens.padding16)) {
            val invalid = state.invalidSelected.size
            when {
                state.itemsToCreate == 0 -> HelperText(stringResource(Res.string.note_import_bulk_nothing_selected))
                invalid > 0 -> HelperText(stringResource(Res.string.note_import_bulk_complete_first, invalid))
            }
            QuipPrimaryButton(
                text = stringResource(Res.string.note_import_bulk_create, state.itemsToCreate),
                onClick = onCreate,
                enabled = state.canCreate,
            )
        }

        BulkStep.CREATING -> Unit
        BulkStep.DONE -> Column(Modifier.padding(QuipDimens.padding16), verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8)) {
            if (state.failedIds.isNotEmpty()) {
                QuipSecondaryButton(text = stringResource(Res.string.note_import_bulk_retry_failed), onClick = onRetry)
            }
            QuipPrimaryButton(text = stringResource(Res.string.note_import_bulk_go_to_garage), onClick = onFinished)
        }
    }
}

@Composable
private fun HelperText(text: String) {
    Text(
        text = text,
        style = MaterialTheme.typography.caption,
        color = QuipColors.colorError,
        modifier = Modifier.padding(bottom = QuipDimens.padding8),
    )
}

// --- Progress and result -------------------------------------------------------------------------

@Composable
private fun ResultList(state: NoteImportBulkUiState, catalog: DSparePartCatalog) {
    val plan = state.plan()
    val titles = plan.vehicles.associate { it.id to vehicleTitle(it) } +
        plan.maintenances.associate { it.id to (it.description?.value ?: maintenanceSubtitle(it)) } +
        plan.spareParts.associate { it.id to partTitle(it, catalog) }
    val done = state.statuses.values.count { it !is ItemStatus.InProgress && it !is ItemStatus.Pending }

    if (state.step == BulkStep.CREATING) {
        Text(
            text = stringResource(Res.string.note_import_bulk_creating, done, titles.size),
            style = MaterialTheme.typography.subtitle1,
            color = QuipColors.colorText,
        )
        LinearProgressIndicator(
            progress = if (titles.isEmpty()) 0f else done.toFloat() / titles.size,
            color = QuipColors.colorPrimary,
            modifier = Modifier.fillMaxWidth(),
        )
    } else {
        val problems = state.failedIds.size
        Text(
            text = stringResource(Res.string.note_import_bulk_done_title),
            style = MaterialTheme.typography.h6,
            fontWeight = FontWeight.Bold,
            color = QuipColors.colorText,
        )
        Text(
            text = stringResource(
                Res.string.note_import_bulk_done_summary,
                state.statuses.values.count { it is ItemStatus.Created },
                problems,
            ),
            style = MaterialTheme.typography.body2,
            color = if (problems > 0) QuipColors.colorError else QuipColors.colorTextSecondary,
        )
    }
    titles.forEach { (id, title) ->
        val status = state.statuses[id] ?: ItemStatus.Pending
        if (plan.vehicles.any { it.id == id && !state.isNew(it) }) return@forEach // attached, not created
        Row(verticalAlignment = Alignment.CenterVertically, modifier = Modifier.fillMaxWidth()) {
            when (status) {
                ItemStatus.InProgress -> CircularProgressIndicator(modifier = Modifier.size(QuipDimens.iconSize20), strokeWidth = QuipDimens.padding2)
                is ItemStatus.Created, is ItemStatus.AlreadyExisted ->
                    Icon(Icons.Default.CheckCircle, contentDescription = null, tint = QuipColors.colorSuccess, modifier = Modifier.size(QuipDimens.iconSize20))
                is ItemStatus.Failed, is ItemStatus.Blocked ->
                    Icon(Icons.Default.Warning, contentDescription = null, tint = QuipColors.colorError, modifier = Modifier.size(QuipDimens.iconSize20))
                ItemStatus.Pending -> Spacer(Modifier.size(QuipDimens.iconSize20))
            }
            Spacer(Modifier.width(QuipDimens.padding12))
            Column(Modifier.weight(1f)) {
                Text(title, style = MaterialTheme.typography.body1, color = QuipColors.colorText)
                statusText(status)?.let { (text, color) ->
                    Text(text, style = MaterialTheme.typography.caption, color = color)
                }
            }
        }
    }
}

@Composable
private fun statusText(status: ItemStatus): Pair<String, Color>? = when (status) {
    is ItemStatus.Created -> stringResource(Res.string.note_import_bulk_result_created) to QuipColors.colorSuccess
    is ItemStatus.AlreadyExisted -> stringResource(Res.string.note_import_bulk_result_existing) to QuipColors.colorTextSecondary
    is ItemStatus.Failed -> listOfNotNull(stringResource(Res.string.note_import_bulk_result_failed), status.message)
        .joinToString(": ") to QuipColors.colorError
    is ItemStatus.Blocked -> stringResource(
        when (status.reason) {
            BlockReason.VEHICLE_NOT_CREATED -> Res.string.note_import_bulk_result_blocked_vehicle
            BlockReason.INCOMPLETE -> Res.string.note_import_bulk_result_blocked_incomplete
            BlockReason.NO_VEHICLE -> Res.string.note_import_bulk_result_blocked_no_vehicle
        }
    ) to QuipColors.colorError
    ItemStatus.Pending, ItemStatus.InProgress -> null
}

// --- Edit dialogs -------------------------------------------------------------------------------

private fun <T> userValue(value: T): SuggestedField<T> = SuggestedField(value, ExtractionConfidence.HIGH, FieldSource.USER)

/** Keeps the original suggestion when the text did not change, otherwise records the user's value. */
private fun editedText(original: SuggestedField<String>?, text: String): SuggestedField<String>? = when {
    text.isBlank() -> null
    original?.value == text.trim() -> original
    else -> userValue(text.trim())
}

@Composable
private fun EditDialog(title: String, onDismiss: () -> Unit, onApply: () -> Unit, content: @Composable () -> Unit) {
    QuipDialogGeneric(
        title = title,
        content = {
            Column(
                modifier = Modifier.verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(QuipDimens.padding8),
            ) { content() }
        },
        confirmButtonText = stringResource(Res.string.note_import_bulk_apply),
        dismissButtonText = stringResource(Res.string.cancel),
        onConfirm = onApply,
        onDismiss = onDismiss,
    )
}

@Composable
private fun VehicleEditDialog(vehicle: VehicleDraft, onDismiss: () -> Unit, onApply: (VehicleDraft) -> Unit) {
    var vin by remember { mutableStateOf(vehicle.vin?.value.orEmpty()) }
    var plate by remember { mutableStateOf(vehicle.plate?.value.orEmpty()) }
    var brand by remember { mutableStateOf(vehicle.brand?.value.orEmpty()) }
    var model by remember { mutableStateOf(vehicle.model?.value.orEmpty()) }
    var year by remember { mutableStateOf(vehicle.year?.value?.toString().orEmpty()) }
    var color by remember { mutableStateOf(vehicle.color?.value.orEmpty()) }
    var owner by remember { mutableStateOf(vehicle.owner?.value.orEmpty()) }

    EditDialog(
        title = stringResource(Res.string.note_import_bulk_edit_vehicle),
        onDismiss = onDismiss,
        onApply = {
            onApply(
                vehicle.copy(
                    vin = editedText(vehicle.vin, vin.uppercase()),
                    plate = editedText(vehicle.plate, plate.uppercase()),
                    brand = editedText(vehicle.brand, brand),
                    model = editedText(vehicle.model, model),
                    year = year.trim().toIntOrNull()?.let { if (it == vehicle.year?.value) vehicle.year else userValue(it) },
                    color = editedText(vehicle.color, color),
                    owner = editedText(vehicle.owner, owner),
                )
            )
        },
    ) {
        QuipTextField(value = vin, onValueChange = { vin = it }, label = stringResource(Res.string.vin), isError = vin.isBlank())
        QuipTextField(value = plate, onValueChange = { plate = it }, label = stringResource(Res.string.plate), isError = plate.isBlank())
        QuipTextField(value = brand, onValueChange = { brand = it }, label = stringResource(Res.string.brand), isError = brand.isBlank())
        QuipTextField(value = model, onValueChange = { model = it }, label = stringResource(Res.string.model), isError = model.isBlank())
        QuipTextField(
            value = year,
            onValueChange = { year = it.filter(Char::isDigit).take(4) },
            label = stringResource(Res.string.year),
            isError = year.isBlank(),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
        )
        VehicleColorPicker(
            selectedColorId = color,
            onColorSelected = { color = it.id },
            label = stringResource(Res.string.color),
            isError = color.isBlank(),
        )
        QuipTextField(value = owner, onValueChange = { owner = it }, label = stringResource(Res.string.owner), isError = owner.isBlank())
    }
}

@Composable
private fun MaintenanceEditDialog(maintenance: MaintenanceDraft, onDismiss: () -> Unit, onApply: (MaintenanceDraft) -> Unit) {
    var date by remember { mutableStateOf(maintenance.date?.value) }
    var kilometers by remember { mutableStateOf(maintenance.kilometers?.value?.toString().orEmpty()) }
    var cost by remember { mutableStateOf(maintenance.cost?.value?.let { if (it % 1.0 == 0.0) it.toLong().toString() else it.toString() }.orEmpty()) }
    var description by remember { mutableStateOf(maintenance.description?.value.orEmpty()) }

    EditDialog(
        title = stringResource(Res.string.note_import_bulk_edit_maintenance),
        onDismiss = onDismiss,
        onApply = {
            onApply(
                maintenance.copy(
                    date = date?.let { if (it == maintenance.date?.value) maintenance.date else userValue(it) },
                    datePrecision = if (date != maintenance.date?.value) null else maintenance.datePrecision,
                    kilometers = kilometers.trim().toIntOrNull()?.let { if (it == maintenance.kilometers?.value) maintenance.kilometers else userValue(it) },
                    cost = cost.trim().replace(',', '.').toDoubleOrNull()?.let { if (it == maintenance.cost?.value) maintenance.cost else userValue(it) },
                    description = editedText(maintenance.description, description),
                )
            )
        },
    ) {
        DatePickerField(label = stringResource(Res.string.date_label), currentDate = date, onDateSelected = { date = it })
        QuipTextField(
            value = kilometers,
            onValueChange = { kilometers = it.filter(Char::isDigit) },
            label = stringResource(Res.string.kilometers_label),
            isError = kilometers.isBlank(),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
        )
        QuipTextField(
            value = cost,
            onValueChange = { cost = it },
            label = stringResource(Res.string.cost_label),
            isError = cost.isBlank(),
            keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
        )
        QuipTextField(value = description, onValueChange = { description = it }, label = stringResource(Res.string.description), minLines = 2)
    }
}

@Composable
private fun SparePartEditDialog(
    part: SparePartDraft,
    catalog: DSparePartCatalog,
    onDismiss: () -> Unit,
    onApply: (SparePartDraft) -> Unit,
) {
    var categoryId by remember { mutableStateOf(part.categoryId?.value) }
    var typeId by remember { mutableStateOf(part.typeId?.value) }
    var brand by remember { mutableStateOf(part.brand?.value.orEmpty()) }
    var model by remember { mutableStateOf(part.model?.value.orEmpty()) }
    var reference by remember { mutableStateOf(part.reference?.value.orEmpty()) }
    var quantity by remember { mutableStateOf(part.quantity?.value?.toString().orEmpty()) }
    val types: List<DSparePartType> = catalog.sparePartTypes.values.filter { it.categoryId == categoryId }
    val selectedType = typeId?.let { catalog.sparePartTypes[it] }
    val categoryNames = catalog.categories.mapValues { (_, key) -> getSparePartCategoryString(key) }
    val typeNames = types.associate { it.id to getSparePartTypeString(it.translationKey) }

    EditDialog(
        title = stringResource(Res.string.note_import_bulk_edit_spare_part),
        onDismiss = onDismiss,
        onApply = {
            onApply(
                part.copy(
                    categoryId = categoryId?.let { if (it == part.categoryId?.value) part.categoryId else userValue(it) },
                    typeId = typeId?.let { if (it == part.typeId?.value) part.typeId else userValue(it) },
                    brand = editedText(part.brand, brand),
                    model = editedText(part.model, model),
                    reference = editedText(part.reference, reference),
                    quantity = quantity.trim().replace(',', '.').toDoubleOrNull()?.takeIf { it > 0 }
                        ?.let { if (it == part.quantity?.value) part.quantity else userValue(it) },
                    unit = selectedType?.unit?.let { userValue(it) } ?: part.unit,
                )
            )
        },
    ) {
        QuipDropdownTextField(
            options = catalog.categories.keys.toList(),
            selectedOption = categoryId,
            itemToStringTitle = { categoryNames[it] ?: it },
            label = stringResource(Res.string.category_header),
            isError = categoryId == null,
            onOptionSelected = { _, option ->
                if (option != categoryId) typeId = null
                categoryId = option
            },
        )
        QuipDropdownTextField(
            options = types.map { it.id },
            selectedOption = typeId,
            itemToStringTitle = { typeNames[it] ?: it },
            label = stringResource(Res.string.spare_part_type_label),
            isEnabled = categoryId != null,
            isError = typeId == null,
            onOptionSelected = { _, option -> typeId = option },
        )
        QuipTextField(value = brand, onValueChange = { brand = it }, label = stringResource(Res.string.brand), isError = brand.isBlank())
        QuipTextField(value = model, onValueChange = { model = it }, label = stringResource(Res.string.model), isError = model.isBlank())
        QuipTextField(value = reference, onValueChange = { reference = it }, label = stringResource(Res.string.reference_optional_label))
        if (selectedType?.hasQuantity == true) {
            QuipTextField(
                value = quantity,
                onValueChange = { quantity = it },
                label = stringResource(Res.string.quantity_label).trimEnd(':') + (selectedType.unit?.let { " ($it)" } ?: ""),
                keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Decimal),
            )
        }
    }
}
